import React from 'react';
import LaptopImage from '../assets/laptop.png';
import Bg from '../assets/bg.png';
import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import { FormattedMessage } from 'react-intl';

const Wrapper = styled.div`
  padding-top: 30px;
  text-align: center;

  ${breakpoint('tablet')`
    padding-top: 53px;
    background-image: url(${Bg});
    background-repeat: no-repeat;
    background-position: center 60%;
    width: 819px;
  `};
`;

const H1 = styled.h1`
  color: #242424;
  font-size: 18px;
  font-weight: bold;
  line-height: 21px;
  text-align: center;

  ${breakpoint('tablet')`
    font-size: 38px;
    line-height: 43px;
  `};
`;

const Hr = styled.hr`
  border: none;
  height: 1px;
  width: 275px;
  opacity: 0.9;
  background: radial-gradient(circle, #fdba29 0%, #ffffff 100%);
  margin-bottom: 30px;

  ${breakpoint('tablet')`
    margin-bottom: 43px;
    width: 616px;
  `};
`;

const Image = styled.img`
  width: 267px;
  height: 154px;
  margin-bottom: 30px;

  ${breakpoint('tablet')`
    width: 621px;
    height: 358px;
  `};
`;

const TopBlock = () => {
  return (
    <Wrapper>
      <H1>
        <FormattedMessage
          id="shop.block.top"
          defaultMessage="Открой свой интернет - магазин!"
        />
      </H1>
      <Hr />
      <Image src={LaptopImage} alt="" />
    </Wrapper>
  );
};

export default TopBlock;



// WEBPACK FOOTER //
// ./src/routes/Shop/blocks/top.js